module.exports = __webpack_public_path__ + "img/Ident-Process-5.24d404c7.png";